import React, { useContext } from 'react';
import { Menu, MenuItem, ListItemIcon, Tooltip } from '@mui/material';
import { Menu as MenuIcon, Group as GroupIcon, LocationOn as LocationOnIcon, Work as WorkIcon, CalendarMonth as CalendarMonthIcon } from '@mui/icons-material';
import Context from "../context";

export default function ActionsList() {
    const { state, dispatch } = useContext(Context);

    const handleClick = (event) => {
        dispatch({ type: 'SET_ANCHOR_EL', anchor_el: event.currentTarget });
    };

    const handleSelector = (type) => {
        dispatch({ type: 'SET_SELECTOR', selector: type });
    };

    const iconMap = {
        "ALL": <MenuIcon onClick={handleClick} style={{ marginTop: '-10px' }} />,
        "FTM": <GroupIcon onClick={handleClick} style={{ marginTop: '-10px' }} />,
        "POSTCODE": <LocationOnIcon onClick={handleClick} style={{ marginTop: '-10px' }} />,
        "JOBS": <WorkIcon onClick={handleClick} style={{ marginTop: '-10px' }} />,
        "JOBS_CREATEDAT": <CalendarMonthIcon onClick={handleClick} style={{ marginTop: '-10px' }} />,
    };

    return (
        <>
            <Tooltip title={state.selector} arrow placement="right">
                {iconMap[state.selector]}
            </Tooltip>
            <Menu
                anchorEl={state.anchor_el}
                open={Boolean(state.anchor_el)}
                onClose={() => dispatch({ type: 'SET_ANCHOR_EL', anchor_el: null })}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                {Object.entries(iconMap).map(([type, Icon]) => (
                    <MenuItem key={type} onClick={() => handleSelector(type)}>
                        <ListItemIcon>{Icon.props.children}</ListItemIcon>
                        {type}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}